// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
  },
  text1: {
    marginTop: 35,
    marginBottom: 24,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_GREY,
    textAlign: 'center',
    width: 380,
    [theme.breakpoints.down(400)]: {
      width: '95%',
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: 380,
    [theme.breakpoints.down(400)]: {
      width: '95%',
    },
  },
  helperText: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    marginTop: 16,
    width: 380,
    [theme.breakpoints.down(400)]: {
      width: '95%',
    },
  },
  error: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_REJECT,
  },
  buttonWithError: {
    marginTop: 10,
    width: 200,
  },
  button: {
    marginTop: 24,
    width: 200,
    padding: '12px 15px',
  },
  secondButton: {
    marginTop: 10,
    width: 200,
  }
});

export default styles;
